import {
  adjectives,
  animals,
  colors,
  uniqueNamesGenerator,
} from "unique-names-generator";

const baseConfig = {
  dictionaries: [adjectives, colors, animals],
  length: 3,
  separator: "-",
  style: "lowerCase" as const,
};

/** One random suggested environment name (no seed — different each call). */
export function generateEnvironmentDisplayName(): string {
  return uniqueNamesGenerator(baseConfig);
}

/**
 * A fresh pair of GPU vs CPU placeholders for one create-environment flow.
 * Regenerated when the create UI mounts again (e.g. next environment).
 */
export function createGpuCpuEnvironmentPlaceholderPair(): {
  gpu: string;
  cpu: string;
} {
  return {
    gpu: generateEnvironmentDisplayName(),
    cpu: generateEnvironmentDisplayName(),
  };
}
